import React, { useEffect, useRef, useState } from 'react'
import HospitalSidebar from '../../components/HospitalSidebar/HospitalSidebar'
import QR from './dummyQr.png'
import { useDispatch, useSelector } from 'react-redux'
import { hospitalActions, userActions } from '../../_actions'
import { HiOutlineClipboardDocument } from "react-icons/hi2";
import { FaRegFilePdf } from "react-icons/fa";
import LoadingOverlay from 'react-loading-overlay';
import ReactPaginate from 'react-paginate';
import Generatedqr from './Generatedqr'
export default function  SubscriptionHospital() {

  let [error, setError] = useState({});
  let handleImageChange = (e) => {
    setError({...error,imageName:""})
    dispatch(hospitalActions.uploadImageDocument({ image: e.target.files[0] }))
  }
  let dispatch = useDispatch()
  let selector = useSelector(state => state)
  let data = {
    "keyWord": "",
    "pageNo": 1,
    "size": 10
  }


  let { users, hospital } = selector
  let { SubscriptionList, physioAllSubscriptionList, loading,appSettingData,bankData

  } = selector && selector?.users;
  let {bankDetails} =bankData&&bankData?bankData:{}
  

  let { total, list } = physioAllSubscriptionList || {}






  useEffect(() => {
    dispatch(hospitalActions.getHospitalProfile(data));

    dispatch(userActions.getSubscriptionRequestListHospital(data))
    dispatch(userActions.getAllPackageForHospital())
    dispatch(userActions.bankDetails())
  }, [])

  const [selectedOption, setSelectedOption] = useState('');
  const [Inputdata, setInputdata] = useState({});
  let [amount, setamount] = useState({})
  const handleOptionChange = (event) => {
    let { name, value } = event
    setError({...error,selectedOption:""})
    console.log(name, value, selectedOption)
    setSelectedOption(event.target.value);
  };
  // useEffect()
  const handleInputChange = (e) => {
    
    let { name, value } = e.target;
    setError({...error,txn:" "})
    setInputdata({ ...Inputdata, [name]: value })
  }
  let [paymentMode,setpaymentMode]=useState("")
  let handleInputChanges = (e)=>{
    setError({...error,paymentMode:""})
    setpaymentMode(e.target.value)
  }

  let [validForm, setValidForm] = useState(false);
  
  let handleForm = () => {
    let newErrors = {};
  
    if (!selectedOption) {
      newErrors.selectedOption = "Please select a plan.";
      setValidForm(false);
    }
  
    if (!paymentMode) {
      newErrors.paymentMode = "Please select a Payment Mode.";
      setValidForm(false);
    }
  
    if (!Inputdata.txn) {
      newErrors.txn = "Please enter a transaction ID.";
      setValidForm(false);
    }
  
    if (!hospital?.Doc_filesDetails?.imageName) {
      newErrors.imageName = "Please upload a payment image.";
      setValidForm(false);
    }
  
    setError(newErrors);
    console.log(error, validForm);
    setValidForm(Object.keys(newErrors).length === 0);
  };
  
  let handleSubmit = () => {

    handleForm();

    if (validForm) {
      let data = {
        "keyWord": "",
        "pageNo": 1,
        "size": 10
      };
      let obj = {
        image: hospital?.Doc_filesDetails?.imageName || " ",
        txId: Inputdata?.txn,
        packageId: selectedOption,
        amount: amount?.amount || "",
        pamentMode: paymentMode,
      };
      console.log(obj);
  
      dispatch(hospitalActions.createSubscriptionRequestHospital(obj, data));
      dispatch(userActions.uploadImageClear());
      setInputdata();
      setpaymentMode("")
      setSelectedOption("");
      setInputdata("")
    }
  };
  
  useEffect(() => {
    let data = list?.filter((e) => e?.id == selectedOption)
    { data && data[0] && setamount({ amount: data[0]?.amount }) }
  }, [selectedOption])
  //--------Pagination-------------------------
  const [size, setSize] = useState(10);
  const [isMobile, setIsMobile] = useState(true);
  const handlePageClick = (data) => {
    console.log(size)
    console.log('Page clicked:', data.selected + 1);
    let datas = {
      "keyWord": "",
      "pageNo": data.selected + 1,
      "size": 10
    }
    dispatch(userActions.getSubscriptionRequestListHospital(datas))
  };
  //--------Pagination-------------------------


console.log(bankDetails)
  return (
    <div className='flex'>
      <div >
        <LoadingOverlay
          active={loading}
          className="temp001"
          spinner
          text='Please wait...' />
      </div>
      <div>
        <HospitalSidebar />
      </div>

      <div className='flex  flex-col w-full'>
        <div className=' mx-4 mt-2 p-5 bg-gray-200 rounded-lg'>
          <h1 className=' text-xl font-bold '>SUBSCRIPTION </h1>
        </div>
        <div className='w-full p-5 h-[80vh] overflow-y-auto pb-10 overflow-hidden space-y-6'>
          <div className='bg-white rounded-lg flex w-full 2xl:flex-row flex-col'>
            <div className='flex-1 items-center flex justify-center'>
              <div className=' h-1/2 md:w-[30rem] w-[20rem]  flex gap-2 flex-col items-center justify-center '>
              <div className='flex-1 border-2 border-[#005F60] p-2 flex justify-center items-center'><Generatedqr upiId={bankDetails?.upiId||""} name={bankDetails?.name||""}/>
            
            </div>
                <button className='bg-[#005F60] text-white text-xl rounded-lg py-2  px-5'>Scan & PayNow</button>
                <div className=' flex-1 gap-2 pt-2 mt-2  w-full'>
                  <div className='bg-[#005F60] text-white rounded-lg flex flex-col  gap-2  px-3 py-2'>


                  <div className='flex  text-lg bottom-3 font-bold  justify-between'>
                      <div >Account Number</div>
                      <div className='flex items-center gap-1'>{bankDetails?.accountNo||"--"}<span title='copy' className='cursor-pointer' ></span></div>
                    </div>

                    <div className='flex  font-bold text-lg justify-between'>
                      <div>Account Holder Name</div>
                      <div className='flex items-center gap-1'>{bankDetails?.name||"--"}<span title='copy' className='cursor-pointer' ></span></div>
                    </div>

                    <div className='flex  text-lg bottom-3 font-bold  justify-between'>
                      <div >Bank Name</div>
                      <div className='flex items-center gap-1'>{bankDetails?.bankName||"--"}<span title='copy' className='cursor-pointer' ></span></div>
                    </div>

                    <div className='flex  text-lg bottom-3 font-bold  justify-between'>
                      <div >IFSC Code</div>
                      <div className='flex items-center gap-1'>{bankDetails?.ifsc||"--"}<span title='copy' className='cursor-pointer' ></span></div>
                    </div>

                    <div className='flex  text-lg bottom-3 font-bold  justify-between'>
                      <div >Upi Id</div>
                      <div className='flex items-center gap-1'>{bankDetails?.upiId||"--"}<span title='copy' className='cursor-pointer' ></span></div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <div className=' flex-1  flex flex-col items-center  border-l-2  justify-center p-4'>
              <div className='  pb-2 bg-[#005F60] border border-[#005F60] md:w-[30rem] w-[20rem]  rounded-md  mb-2 p-2'>
                <div className='   h-full shadow-md'>


                  <div className='text-lg text-white font-semibold'>Choose Plan</div>
                  <select className='w-full p-3 outline-none bg-white flex  justify-between' id="dropdown" value={selectedOption} onChange={handleOptionChange}>
                    <option value="">--Please choose an option--</option>
                    {list?.map(option => (
                      <option key={option?.id} value={option?.id}>
                        {`${option?.name} in ₹${option?.amount} for ${option?.duration}Days`}
                      </option>
                    ))}
                  </select>
                    {error["selectedOption"]?<div className=' text-sm text-red-500'>{error.selectedOption}</div>:""}

                </div>
              </div>
              <div className='  bg-[#005F60] md:w-[30rem] w-[20rem]  shadow p-5 '>


                <div className='flex flex-col h-full justify-between'>

                  <div className=' h-[6rem] flex-1 w-full'>
                    <div className='text-white font-bold'>Upload Payment Image</div>
                    <input type='file' className='w-full p-3 outline-none bg-white flex justify-between' onChange={handleImageChange} placeholder='Upload your File' />
                  {error["imageName"]?<div className=' text-sm text-red-500'>{error.imageName}</div>:""}
                  </div>
                  <div className=' h-[6rem] pt-2 flex-1 w-full'>
                    <div className='text-white font-bold'>Select Payment Method:</div>
                    <select onChange={handleInputChanges} value={paymentMode}  id="payment-method" className=' w-full p-3 outline-none' name="pamentMode">
                      <option value="" selected disabled>Select Payment Method</option>
                      <option value="BANK AC">Bank Transfer</option>
                      <option value="UPI">UPI</option>
                      {/* <option value="AC">Account Transfer</option> */}
                    </select>
                    {error["paymentMode"]?<div className=' text-sm text-red-500'>{error.paymentMode}</div>:""}
                  </div>
                  <div className=' h-[6rem] pt-5 w-full'>
                    <div className='text-lg  text-white font-bold'>Transaction ID:</div>
                    <input className='w-full p-3 outline-none' name='txn' type='text' value={Inputdata.txn} onChange={handleInputChange} placeholder='Transaction ID' />
                    
                    {error["txn"]&&error["txn"]!=""?<div className=' text-sm text-red-500'>{error.txn}</div>:""}
                  </div>
                  <div className='flex items-center justify-center h-[5rem] w-full'>
                    <button onClick={handleSubmit} className='bg-[white] text-[#005F60] text-lg font-bold rounded-lg px-5 py-3'>Submit</button>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className='bg-white mt-1 rounded-t-md overflow-x-auto'>
            <table>
              <tbody className='bg-[#005F60] rounded-t-md'>
                <th>S.No</th>
                <th>Package Name</th>
                <th>Amount</th>
                <th>Duration</th>
                <th>PaymentMode</th>
                <th>Image</th>
                <th>Status</th>
              </tbody>
              {SubscriptionList && SubscriptionList.list.length > 0 && (
                <tbody className='rounded-t-md border-2'>
                  <td className='text-black'>1</td>
                  <td className='text-black'>{SubscriptionList.list[0]?.packageId?.name || "--"}</td>
                  <td className='text-black'>{SubscriptionList.list[0]?.packageId?.amount || "--"}</td>
                  <td className='text-black'>{SubscriptionList.list[0]?.packageId?.duration || "--"}</td>
                  <td className='text-black'>{SubscriptionList.list[0]?.pamentMode || "--"}</td>
                  
                  <td className='text-black'>
  {SubscriptionList.list[0]?.imageLinkUrl.endsWith('.pdf') ? (
    <FaRegFilePdf className='w-10 h-10 text-red-500' />
  
  ) : (
    <img className='w-10 h-10' src={SubscriptionList.list[0]?.imageLinkUrl || "--"} alt='no image' />
  )}
</td>
                  {SubscriptionList.list[0]?.status == 0 && <td className='text-blue-600 font-bold'>Pending</td>}
                  {SubscriptionList.list[0]?.status == 1 && <td className='text-green-600 font-bold'>Approved</td>}
                  {SubscriptionList.list[0]?.status == 2 && <td className='text-red-600 font-bold'>Rejected</td>}
                </tbody>
              )}



            </table>

          </div>
        </div>
      </div>
    </div>

  )
}
